var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }